export const executePrint = (
    action,
    format,
    isAttachments,
    copies,
    isPdf,
    isQuickPrint,
    printorig
) => {
    window['procPrint'] &&
        window['procPrint']['executePrint'](
            action,
            format,
            isAttachments,
            copies,
            isPdf,
            isQuickPrint,
            printorig
        );
};

export const openDesignReportPanel = isWord => {
    window['procPrint'] && window['procPrint']['openDesignPanel'](isWord);
};

export const cancleProcedure = () => {
    window['procPrint'] && window['procPrint']['cancelProcedure']();
};
